
class ModelSocket {

  constructor(socket, store) {
    this._data = [];
    this.connected = false;
    if (!socket) {
      throw new Error('A socket must be passed as argument');
    }
    this.socket = socket;
    this.store = store;
    this.channelName;

  }

  updateSSRData() {
    if (this.store && this.store.state.models[this.label()]) {
      this.data = this.store.state.models[this.label()];
    }
  }

  label() {
    return this.channelName || 'some_model';
  }

  connect(callback = () => {}) {
    this.updateSSRData();

    this.socket.onError(() => {
      console.error(`Unable to connect to socket ${JSON.stringify(this.socket.endPoint)}`);
      this.socket.disconnect();
    });

    this.socket.connect();

    this.connected = true;

    this.joinChannel(callback);

    this.channel.on('update', (message) => {
      this.data = message.data;
    });

    this.channel.on('delete', (message) => {
      this.updateData(message.data, true);
    });
  }

  disconnect(callback = () => {}) {
    if (this.channel) {
      this.channel.leave();
    }
    this.socket.disconnect();
    callback();
  }

  joinChannel(callback = () => {}) {
    if (!this.channelName) {
      throw new Error('this.channelName must be defined');
    }
    this.channel = this.socket.channel(this.channelName, {});
    this.channel.join().receive('ok', (resp) => {
      callback(resp);
      console.log(`Joined channel ${this.channelName} successfully.`);
    }).receive('error', resp => {
      console.error(`Unable to join channel ${this.channelName}.`, resp);
    });
  }

  get list() {
    let data;

    if (this.store) {
      data = this.store.state.models[this.label()];
    } else {
      data = this._data;
    }

    if (!Array.isArray(data)) {
      return [data];
    } else {
      return data;
    }
  }

  get data() {
    let data;

    if (this.store) {
      data = this.store.state.models[this.label()];
    } else {
      data = this._data;
    }

    if (Array.isArray(data)) {
      return data[0];
    } else {
      return data;
    }
  }

  set data(data) {
    this.updateData(data);
  }

  updateData(data, mustDelete = false) {
    if (Array.isArray(data)) {
      this._data = data;
    } else if (data.hasOwnProperty('_id')) {
      let index = -1;
      this._data.forEach((item, i) => {
        if (item && item._id === data._id) {
          index = i;
          if (!mustDelete) {
            Object.assign(item, data);
          }
        }
      });
      if (index === -1) {
        this._data.push(data);
      } else if (mustDelete) {
        this._data.splice(index, 1);
      }
    } else if (data) {
      console.warn('Setting non Array data without _id property. It can causes undesired behaviours.');
      this._data = data;
    }

    if (this.store) {
      this.store.commit('SET_MODEL_DATA', { model: this.label(), data: this._data });
    }
  }

  channelPush(action, params, callback, errorCallback = () => {}) {
    if (!this.connected) {
      this.connect();
    }
    this.channel.push(action, params)
    .receive('ok', callback)
    .receive('error', (error) => {
      errorCallback(error);
      console.error(`Unable to ${action} in channel ${this.channelName} with params`, params, error);
    });
  }

  find(params = {}, callback = () => {}) {
    this.channelPush('find', params, (resp) => {
      this.data = resp.data;
      callback(resp);
    });
  }

  get(params = {}, callback = () => {}, error = () => {}) {
    this.channelPush('get', params, (resp) => {
      this.data = [resp.data];
      callback(resp);
    }, error);
  }

  delete(params = {}, callback = () => {}) {
    this.channelPush('delete', params, (resp) => {
      callback(resp);
    });
  }

  update(params = {}, callback = () => {}) {
    this.channelPush('update', params, (resp) => {
      callback(resp);
    });
  }

  create(params = {}, callback = () => {}) {
    this.channelPush('create', params, (resp) => {
      callback(resp);
    });
  }
}

export default ModelSocket;
